export default defineNuxtPlugin((nuxtApp) => {
  const isMobile = useIsMobile()

  // Cached SSR HTML must have the same initial condition for every visitor.
  // Reading the request user-agent here made a cached desktop/mobile response
  // disagree with the browser during hydration.
  isMobile.value = false

  if (import.meta.server) return

  const updateIsMobile = () => {
    isMobile.value = window.matchMedia('(max-width: 768px)').matches
      || /Mobi|Android/i.test(navigator.userAgent)
  }

  // Keep the server-rendered tree intact through hydration, then adapt the UI.
  nuxtApp.hook('app:mounted', updateIsMobile)
})
